import React, { useEffect, useState } from 'react';
import { StoreProvider, updateData, useConditionedNavigator } from '../../../store/ConditionenNavigationProvider';
import { DetailsAudioPage, EditTranscription, ErrorUploadPage, FactoryChat, ListTranscription, LoadingBubble, RecordPage, SelectClassProfile, SelectFilePage, SelectMethod, SelectPlan, TranscriptionProcessing, TranscriptionReady, UploadFile, UploadingPage } from './component';
import { ChatProvider } from '../../../store/chatProvider';
import ChatSkeleton from '../../../components/skeletons/ChatSkeleton';
import { useFeedBackScreenChat, useFeedBackSessionEnadScreen, useLoadUtilsData } from './hook';
import { useQueryAdapter } from '../../../hooks/useQueries';
import { listTranscription } from '../../../services/transcript.service';
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from 'react-router-dom';
import { ChatInput } from '../../../components/globals/chat-input';
import useGlobalStore from '../../../store/useGlobalStore';
import { Chat, ChatScreen } from '../../../components/globals/chat/ChatScreen';
import SuperpowerFormSkeleton from '../../../components/skeletons/SuperpowerFormSkeleton';

export const sizeinmb = 30;
export const Pages = ({ id, data: dataArgs = {} }) => {
    const { currentItem: currentData, dispatch } = useConditionedNavigator();
    const { data, isLoading } = useQueryAdapter({ fnquery: listTranscription, data: id, name: 'listTranscription' });
    const { transcriptions } = data ?? {};
    const { dataPlanning } = dataArgs ?? {};
    useEffect(() => {
        if (dataPlanning?.value) updateData(dispatch, { idClassProfile: id, listtrascrips: null, __listtrascrips: transcriptions, plan: dataPlanning });
        else updateData(dispatch, { idClassProfile: id, listtrascrips: transcriptions, __listtrascrips: transcriptions });
    }, [id, dispatch, transcriptions, dataPlanning]);
    if (currentData?.__isedit) {
        if (currentData?.keytranscriptionedit) return <EditTranscription sizeinmb={sizeinmb} />;
        if (currentData?.trancriptionprocesses) return <TranscriptionProcessing />;
        if (currentData?.keytranscription) return <TranscriptionReady sizeinmb={sizeinmb} />;
        if (currentData?.key) return <DetailsAudioPage sizeinmb={sizeinmb} />;
    } else {
        if (currentData?.listtrascrips?.length || isLoading) return <ListTranscription data={currentData?.listtrascrips} />;
        if (!currentData?.plan) return <SelectPlan />;
        if (!currentData?.method) return <SelectMethod sizeinmb={sizeinmb} />;
        if (!currentData?.succes && currentData?.messageError) return <ErrorUploadPage sizeinmb={sizeinmb} />;
        if (currentData?.keytranscriptionedit) return <EditTranscription sizeinmb={sizeinmb} />;
        if (currentData?.keytranscription) return <TranscriptionReady sizeinmb={sizeinmb} />;
        if (currentData?.uploading) return <UploadingPage />;
        if (currentData?.trancriptionprocesses) return <TranscriptionProcessing />;
        if (currentData?.key) return <DetailsAudioPage sizeinmb={sizeinmb} />;
        if (currentData?.file) return <UploadFile sizeinmb={sizeinmb} />;
        if (currentData?.method === 'upload') return <SelectFilePage sizeinmb={sizeinmb} />;
        if (currentData?.method === 'record') return <RecordPage sizeinmb={sizeinmb} />;
    }
    return null;
}

export const Trancripts = ({ id = 523, data }) => {
    return (
        <StoreProvider >
            <Pages id={id} data={data} />
        </StoreProvider>
    );
}


export const FeedBackScreenChat = () => {
    const { refScroll, messages, state, isLoading, bindChat } = useFeedBackScreenChat();
    return (
        <>
            <ChatScreen pageLabel="enad_feed_back_session" slug="feedback-enad_step_2" route={"/feedback?sessionId"}>
                <Chat refScroll={refScroll}>
                    {isLoading ? <LoadingBubble key={"loading"} /> : null}
                    {messages?.map((i, index, arr) => (
                        <FactoryChat
                            {...i}
                            state={state}
                            key={i.index}
                            isFirst={!index}
                        />
                    ))}
                </Chat>
                <ChatInput {...bindChat} />
            </ChatScreen>
        </>
    );
}

export const FeedBack = ({ idClassProfile, sessionId, keytranscription }) => {
    const { isLoading, data } = useLoadUtilsData({ idClassProfile, keytranscription, sessionId });
    if (isLoading) return <ChatSkeleton />;
    if (!data?.classProfile?.id) return <div></div>
    return <ChatProvider data={data}><FeedBackScreenChat /></ChatProvider>
}

export const FeedBackScreen = () => {
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.search);
    const [sessionId, setSessionId] = useState(queryParams.get('sessionId'));
    const [superPowerconectionLocal, setSuperPowerconectionLocal] = useState(null);
    const { superPowerconection, setSuperPowerconection } = useGlobalStore();
    useEffect(() => {
        if (superPowerconection) {
            setSuperPowerconectionLocal(superPowerconection);
            setSuperPowerconection(null);
        }
    }, [superPowerconection, setSuperPowerconection]);
    useEffect(() => {
        if (!sessionId) {
            const _sessionId = uuidv4();
            setSessionId(_sessionId);
            navigate(`/feedback?sessionId=${_sessionId}`, { replace: true });
        }
    }, [navigate, sessionId]);

    return (
        !sessionId ? <ChatSkeleton /> :
            <FeedBack key={queryParams.get('sessionId')} sessionId={queryParams.get('sessionId')} idClassProfile={superPowerconectionLocal?.idClassProfile ?? null} keytranscription={superPowerconectionLocal?.keytranscription} />
    );
}

export const FeedBackSessionEnadScreen = () => {
    const {setClassProfile,classProfile,dataPlanning,isLoadingSession,isLoadingSupper} = useFeedBackSessionEnadScreen();
    const handleOnselect = (data) => {
        setClassProfile(data);
    }
    return <ChatScreen pageLabel="enad_feed_back_session" slug="feedback-enad_step_2" route={"/feedback?sessionId"}>
        <div className='flex flex-col h-full w-full justify-center items-center'>
            <div className='flex flex-col h-full w-full justify-center items-center relative'>
                {isLoadingSession || isLoadingSupper ?
                    <SuperpowerFormSkeleton />
                    : <>
                        {classProfile?.id ? null : <SelectClassProfile onSelect={handleOnselect} />}
                        {classProfile?.id ? <Trancripts id={classProfile?.id} data={{ dataPlanning }} /> : null}
                    </>}
            </div>
        </div>
    </ChatScreen>
}
